export const TextTooltipInterestType = (isBreak: boolean = true) => <div className="tool-tip !z-[99999999]">
    <div className="flex items-start mb-1">
        <span className="inline-block text-white mr-2 text-lg leading-[22px]">•</span>
        <span>
            <b>O = Offering:</b> This firm is offering a secondment for a specialized service.
        </span>
    </div>
    <div className="flex items-start mb-1">
        <span className="inline-block text-white mr-2 text-lg leading-[22px]">•</span>
        <span>
            <b>S = Seeking:</b> This firm is seeking a secondment for a specialized service.
        </span>
    </div>
    <div className="flex items-start">
        <span className="inline-block text-white mr-2 text-lg leading-[22px]">•</span>
        <span>
            <b>O/S = Offering/Seeking:</b> This firm is both offering and seeking a secondment{isBreak ? <br /> : " "}for a specialized service.
        </span>
    </div>
</div>